import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { CgSmile } from "react-icons/cg";

function OurServices() {
  return (
    <>
      <div className="lg:my-14 bg-[#e7f6fd] ">
        <div className="">
          <div className="grid grid-cols-12">
            <div className="col-span-12 lg:col-span-4">
              <img
                className="h-[100vh] lg:h-[150vh] w-full"
                src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1683278617/home_03_image_01_bdm065.jpg"
              />
            </div>
            <div className="col-span-12 lg:col-span-8 mx-5">
              <div className="lg:px-32 py-10 lg:py-28">
                <h1 className="text-[1.125rem] text-[#01cab8] font-[500] py-2">
                  Our services
                </h1>
                <div className="text-[3.75rem] leading-[4.066rem] font-[700] text-[#1d1e21] pb-5">
                  Premium dental care
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3">
                  <div className="col-span-1 my-5">
                    {/* <CgSmile size={40} color="#27b6d2" /> */}
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312529/Group_13169_n0t0ee.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312308/Group_13171_uwj0iw.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312309/Group_13170_pll8ak.png"
                      />
                    </div>
                    <div className="text-lg font-[500] pb-2 pt-4 lg:pt-10">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312309/Group_13167_ievssh.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-16"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312311/Group_13168_moad1h.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684313007/Group_13165_1_iuhkua.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684312310/Group_13166_rzfvnv.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684313100/Group_13164_1_nl6zon.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-1 my-5">
                    <div>
                      <img
                        className="w-20"
                        src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1684313166/Group_13163_1_ngvst1.png"
                      />
                    </div>
                    <div className="text-lg font-[500] py-2">
                      General Dentistry
                    </div>
                    <div className="text-[#747576e4]">
                      Integer vel nisl varius, finibus orci et, congue sapien
                      fusce.
                    </div>
                    <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1 py-3">
                      <div className="">Read More </div>
                      <div className="mt-1">
                        <BsArrowRightShort size={20} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OurServices;
